module.exports = __webpack_public_path__ + "static/parade-2020-house30-6fc5a3f871355346255f0a2d45ee095d.jpg";